var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-top__language",staticStyle:{"user-select":"none"},on:{"click":_vm.toggleLanguage}},[_vm._v(" "+_vm._s(_vm.$i18n.locale)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }